<div id="SL25" class="block  black">
    <video class="video-box" autoplay muted loop playsinline [src]="package.background"
        data-object-fit="cover"></video>
    <div class="black-veil"></div>
    <div class="cage">
        <div data-aos="fade-up" class="ct-start-2-10 ctr-start-1-6 headline_01_xl_semibold text-container title">
            {{ package.title001 | uppercase }}
        </div>
        <div class="cage-10 ct-start-2-10 ctr-start-1-6">
            <div class="flex ct-start-1-10 text-center text-container">
                <div class=" flex-col flex-center slot">
                    <span data-aos="fade-up" class="body_01_xl_light flex-center"> {{ package.line001 }}</span>
                </div>
                <div class=" flex-col flex-center slot">
                    <span data-aos="fade-up" class="body_01_xl_light flex-center"> {{ package.line002 }}</span>
                </div>
                <div class=" flex-col flex-center slot">
                    <span data-aos="fade-up" class="body_01_xl_light flex-center"> {{ package.line003 }}</span>
                </div>
                <div class=" flex-col flex-center slot">
                    <span data-aos="fade-up" class="body_01_xl_light flex-center"> {{ package.line004 }}</span>
                </div>
                <div class=" flex-col flex-center slot">
                    <span data-aos="fade-up" class="body_01_xl_light flex-center"> {{ package.line005 }}</span>
                </div>
            </div>
        </div>
    </div>
</div>
